export function extractIsoDatePartYYYYMMDD(iso: string): string | null {
  const m = /^([0-9]{4}-[0-9]{2}-[0-9]{2})T/.exec(iso);
  return m ? m[1] : null;
}

export function extractIsoTimePartHHMM(iso: string): string | null {
  const m = /^[0-9]{4}-[0-9]{2}-[0-9]{2}T([0-9]{2}:[0-9]{2})/.exec(iso);
  return m ? m[1] : null;
}

function compareStrings(a: string, b: string): number {
  if (a === b) return 0;
  return a < b ? -1 : 1;
}

/**
 * Compares two ISO timestamps in "club" semantics by using the date/time parts in the string.
 *
 * This avoids relying on the browser local timezone for sorting within a day.
 * If the input is not a well-formed ISO with date/time parts, falls back to Date.parse.
 */
export function compareIsoLocalDateTime(aIso: string, bIso: string): number {
  const aDate = extractIsoDatePartYYYYMMDD(aIso);
  const bDate = extractIsoDatePartYYYYMMDD(bIso);
  if (aDate && bDate) {
    const dateCmp = compareStrings(aDate, bDate);
    if (dateCmp !== 0) return dateCmp;

    const aTime = extractIsoTimePartHHMM(aIso);
    const bTime = extractIsoTimePartHHMM(bIso);
    if (aTime && bTime) return compareStrings(aTime, bTime);
  }

  const aMs = Date.parse(aIso);
  const bMs = Date.parse(bIso);
  if (Number.isFinite(aMs) && Number.isFinite(bMs)) return aMs - bMs;
  return compareStrings(aIso, bIso);
}
